import { Configuration, PopupRequest } from "@azure/msal-browser";

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
    auth: {
        clientId: "d51b0ba4-5a9d-4720-9001-7f3f22130347",
        authority: "https://login.microsoftonline.com/1eac135e-ccdf-4d83-8b4f-efc9038309f0",
        redirectUri: process.env.REACT_APP_BASE_REDIRECT,
        postLogoutRedirectUri: process.env.REACT_APP_BASE_REDIRECT
    },
    cache: {
        // localStorage (no sessionStorage) para que la sesión de MSAL se
        // comparta entre pestañas: una pestaña nueva ve la sesión ya existente
        // en vez de no encontrar ninguna y disparar otro loginRedirect.
        cacheLocation: "localStorage",
        // Sin cookies: solo hacían falta para IE11/Edge antiguo. Con ellas, un
        // login a medias (pestaña cerrada durante la redirección a Microsoft)
        // dejaba una cookie "login en curso" que bloqueaba los logins
        // siguientes hasta borrar las cookies del sitio a mano.
        storeAuthStateInCookie: false
    }
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: PopupRequest = {
    scopes: ["https://graph.microsoft.com/.default"]
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};
